import { Grid } from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { useSelector } from "react-redux";

export default function CustomPagination(props) {
  const { page, totalPages, setPage } = props;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{
        marginTop: props.margin
          ? props.margin
          : isDesktopOrLaptop
          ? "78px"
          : "24px",
        marginBottom: props.marginBottom
          ? props.marginBottom
          : isDesktopOrLaptop
          ? "37px"
          : "28px",
      }}
    >
      <div
        style={{
          width: "55px",
          height: "22px",
          borderRadius: "15px",
          border: page === 1 ? "solid 1.5px #979797" : "none",
          backgroundColor: page === 1 ? "" : "#0040ff",
          display: "flex",
          marginRight: "45px",
          justifyContent: "center",
          alignItems: "center",
          cursor: page === 1 ? "unset" : "pointer",
        }}
        onClick={() => {
          if (page > 1) {
            setPage(page - 1);
          }
        }}
      >
        <KeyboardArrowLeft
          style={{ color: page === 1 ? "#808080" : "#f8f8f8" }}
          fontSize="14px"
        />
      </div>
      <p
        style={{
          fontFamily: "Overpass",
          fontSize: "16px",
          color: "#808080",
          letterSpacing: "normal",
          margin: 0,
        }}
      >
        <span style={{ fontWeight: 800, color: "#0040ff" }}>{page}</span>/
        {totalPages}
      </p>
      <div
        style={{
          width: "58px",
          height: "25px",
          borderRadius: "15px",
          border: page === totalPages ? "solid 1.5px #979797" : "none",
          backgroundColor: page === totalPages ? "" : "#0040ff",
          display: "flex",
          marginLeft: "45px",
          justifyContent: "center",
          alignItems: "center",
          cursor: page === totalPages ? "unset" : "pointer",
        }}
        onClick={() => {
          if (page < totalPages) {
            setPage(page + 1);
          }
        }}
      >
        <KeyboardArrowRight
          style={{ color: page === totalPages ? "#808080" : "#f8f8f8" }}
          fontSize="14px"
        />
      </div>
    </Grid>
  );
}
